import React, { useState } from 'react';
import { md, isBlankBlock } from '../utils/markdown';

const MovieSection = () => {
  const [selectedPlatform, setSelectedPlatform] = useState('');
  const [selectedGenre, setSelectedGenre] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [results, setResults] = useState('');

  const MOVIE_API_BASE_URL = 'https://lqwesvse2f.execute-api.ap-northeast-2.amazonaws.com/movie/movie-recommendation';

  const platforms = [
    { id: 'netflix', name: '넷플릭스' },
    { id: 'disneyplus', name: '디즈니플러스' },
    { id: 'coupangplay', name: '쿠팡플레이' }
  ];

  const genres = [
    { id: '28', name: '액션' },
    { id: '12', name: '모험' },
    { id: '35', name: '코미디' },
    { id: '27', name: '공포' },
    { id: '14', name: '판타지' },
    { id: '10749', name: '로맨스' },
    { id: '9648', name: '미스테리' },
    { id: '878', name: 'SF' },
    { id: '10752', name: '전쟁' },
    { id: '16', name: '애니메이션' },
    { id: '99', name: '다큐멘터리' },
    { id: '53', name: '스릴러' }
  ];

  // 장르를 4개씩 그룹으로 나누는 함수
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const genreGroups = chunkArray(genres, 4);

  const fetchMovies = async (type) => {
    if (!selectedPlatform || !selectedGenre) {
      setResults('플랫폼과 장르를 모두 선택해주세요.');
      return;
    }

    setSelectedType(type);
    setResults(`${type === "latest" ? "최신 명작" : "고전 명작"} 데이터를 가져오는 중입니다...`);

    try {
      const response = await fetch(MOVIE_API_BASE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          platform: selectedPlatform,
          genre_id: selectedGenre,
          type: type,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const formattedMovies = data.recommendations
          .split('\n\n')
          .filter(p => !isBlankBlock(p))
          .map(p => `<div class="analysis-paragraph">${md(p.trim())}</div>`)
          .join('');
        setResults(`
          <h3>🎬 ${type === "latest" ? "최신 명작" : "고전 명작"} 추천 결과</h3>
          <div class="analysis-content">${formattedMovies}</div>
        `);
      } else {
        const errorData = await response.json();
        setResults(`에러 발생: ${errorData.message}`);
      }
    } catch (error) {
      console.error(`${type === "latest" ? "최신 명작" : "고전 명작"} 추천 오류:`, error);
      setResults(`서버와 통신 중 오류가 발생했습니다: ${error.message}`);
    }
  };

  return (
    <section className="service-section">
      <h2>영화 추천 AI 서비스</h2>
      <p className="info-text">(3년 기준 추천)</p>
      
      <fieldset className="field-group">
        <legend>플랫폼</legend>
        <div className="button-container">
          {platforms.map(platform => (
            <button
              key={platform.id}
              className={`category-btn ${selectedPlatform === platform.id ? 'selected' : ''}`}
              onClick={() => setSelectedPlatform(platform.id)}
            >
              {platform.name}
            </button>
          ))}
        </div>
      </fieldset>

      <fieldset className="field-group">
        <legend>장르</legend>
        {genreGroups.map((genreGroup, groupIndex) => (
          <div key={groupIndex} className="button-container">
            {genreGroup.map(genre => (
              <button
                key={genre.id}
                className={`category-btn ${selectedGenre === genre.id ? 'selected' : ''}`}
                onClick={() => setSelectedGenre(genre.id)}
              >
                {genre.name}
              </button>
            ))}
          </div>
        ))}
      </fieldset>

      <div className="button-container" style={{ marginTop: '20px', flexDirection: 'column' }}>
        <button
          className={`category-btn ${selectedType === 'latest' ? 'selected' : ''}`}
          onClick={() => fetchMovies('latest')}
          style={{ width: '100%', marginBottom: '10px' }}
        >
          최신 명작 추천
        </button>
        <button
          className={`category-btn ${selectedType === 'classic' ? 'selected' : ''}`}
          onClick={() => fetchMovies('classic')}
          style={{ width: '100%' }}
        >
          고전 명작 추천
        </button>
      </div>

      {results && <div className="results" dangerouslySetInnerHTML={{ __html: results }}></div>}
    </section>
  );
};

export default MovieSection;